export default __webpack_public_path__ + "static/media/group-default.9b90700a.png";